import React, { useState, useEffect } from "react";
import "./App.css";
import LanguageSelect from "./LanguageSelect";
import { languageDataset } from "./language-data";

function App() {
  const [languageIndex, setLanguageIndex] = useState(0);
  const [isOpenLanguageSelect, setIsOpenLanguageSelect] = useState(true);

  return (
    <div className="main-wrapper">
      <img src={languageDataset[languageIndex].topBanner} alt="top banner" />
      <img src={languageDataset[languageIndex].keySteps1} alt="key steps" />
      <a href="tel:011-41236667">
        <img src={languageDataset[languageIndex].callDoc} alt="call now" />
      </a>
      <img src={languageDataset[languageIndex].keySteps2} alt="key steps" />
      <a href="tel:080-68186666">
        <img src={languageDataset[languageIndex].callNow} alt="call now" />
      </a>
      <LanguageSelect
        isOpen={isOpenLanguageSelect}
        setIsOpen={setIsOpenLanguageSelect}
        languageIndex={languageIndex}
        setLanguageIndex={setLanguageIndex}
      />
    </div>
  );
}

export default App;
